import React from "react";
import Header from "../components/layout/Header";
import Sidebar from "../components/layout/Sidebar";
import DashboardStats from "../components/layout/Dashboard/DashboardData";
import RecentOrders from "../components/layout/Dashboard/RecentOrders";
import PaymentOrderTable from "../components/layout/Dashboard/PaymentOrders";
import MeasurementList from "../components/order/MeasurementList";
import QuotationList from "../components/order/QuotationList";
import OrderLists from "../components/order/OrderListing";

const Home = ({ nav }) => {
  return (
    <div className={nav.isSidebar}>
      <Header nav={nav} />
      <Sidebar nav={nav} />
      {/*start content*/}
      <main className="page-content">
        <DashboardStats />
        {/*end row*/}
        <OrderLists limit={5} />
        <PaymentOrderTable />
        <MeasurementList
          title="Recent Measurements"
          limit={5}
          showPagination={false}
          showSearch={true}
        />
        <QuotationList
          title="Recent Quotations"
          limit={5}
          showPagination={false}
          showSearch={true}
          navigateTo="/order/submit-quotation"
        />
      </main>
      <div className="overlay nav-toggle-icon" />

      <a href="" className="back-to-top">
        <i className="bx bxs-up-arrow-alt" />
      </a>
    </div>
  );
};

export default Home;
